import React from 'react';
import { Control, Controller } from 'react-hook-form';
import SelectCombobox from './SelectCombobox';
import { OptionProps } from './SbModel';

interface SelectComboboxSimpleProps {
    name: string;
    control: Control<any>;
    options: OptionProps[];
    placeholder?: string;
    defaultValue?: any;
    showFilmIcon?: boolean;
    handleOnChange?: (value: any) => void;
}

const SelectComboboxSimple: React.FC<SelectComboboxSimpleProps> = ({
    name,
    control,
    options,
    placeholder,
    defaultValue,
    showFilmIcon,
    handleOnChange,
}) => {
    return (
        <Controller
            control={control}
            name={name}
            defaultValue={defaultValue}
            render={({ field: { onChange, value } }) => (
                <SelectCombobox
                    id={name}
                    options={options}
                    initialValue={options.find((o) => o.id === value) || { id: '', name: '' }}
                    onChange={(option) => {
                        onChange(option.id);
                        if (handleOnChange) {
                            handleOnChange(option.id);
                        }
                    }}
                    placeholder={placeholder}
                    showFilmIcon={showFilmIcon}
                />
            )}
        />
    );
};

export default SelectComboboxSimple;
